<app-header></app-header>
<div class="body-container clearfix">
    <button *ngIf="!production" class="btn btn-primary btn-lg auto-populate"
        (click)="onCompleteInformationClick(); $event.preventDefault();">
        <i class="fa fa-check"></i>
    </button>
    <div class="row">
        <div class="col-lg-8 equipment-container-parent">
            <div class="equipment-container">
                <div class="equipment-title">
                    Equipment Description
                </div>
                <div class="equipment-content" *ngFor="let item of items; let i = index">
                    <form [formGroup]="item.form" (ngSubmit)="openSelectOffersDialog(false);">
                        <div class="row" *ngIf="items.length <= 1">
                            <div class="form-group col-12 invoice-type">
                                <div class="row w-100">
                                    <div class="col-xl-4 col-md-5 col-12">
                                        <input type="radio" id="invoice-quote{{i}}" value="true"
                                            [formControl]="useNumber" name="invoice-use-number{{i}}"
                                            (change)="onUseNumberSelected(item);">
                                        <div>Invoice/Quote #</div>
                                    </div>
                                    <div class="col-md-6 col-12">
                                        <input type="radio" id="equipment-description{{i}}" value="false"
                                            [formControl]="useNumber" name="invoice-use-number{{i}}"
                                            (change)="onNotUseNumberSelected(item);">
                                        <div>Equipment Description</div>
                                        <label for="invoice-use-number{{i}}"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-8" *ngIf="useNumber.value == 'true'">
                                <div class="form-row">
                                    <div class="form-group col-md-4 col-6">
                                        <div>Invoice/Quote number:</div>
                                    </div>
                                    <div class="form-group col-md-5 col-6">
                                        <input type="text" formControlName="invoiceNumber" class="form-control"
                                            id="invoiceNumber{{i}}" placeholder="Invoice Number"
                                            name="invoiceNumber{{i}}" (keyup)="onInvoiceNumberKeyUp(item)"
                                            [ngClass]="{ 'is-invalid': submitted && item.iForm.invoiceNumber.errors }">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8" *ngIf="useNumber.value == 'false'">
                                <div class="form-row">
                                    <div class="form-group col-6">
                                        <input type="text" formControlName="make" class="form-control" id="make{{i}}"
                                            placeholder="Make" name="make{{i}}" (keyup)="onMakeOrModelOrYearKeyUp(item)"
                                            [ngClass]="{ 'is-invalid': submitted && item.iForm.make.errors }">
                                    </div>
                                    <div class="form-group col-6">
                                        <input type="text" formControlName="model" class="form-control" id="model{{i}}"
                                            placeholder="Model" name="model{{i}}"
                                            (keyup)="onMakeOrModelOrYearKeyUp(item)"
                                            [ngClass]="{ 'is-invalid': submitted && item.iForm.model.errors }">
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-6">
                                        <input type="text" formControlName="serialNumber" class="form-control"
                                            id="serialNumber{{i}}" placeholder="Serial Number" name="serialNumber{{i}}"
                                            [ngClass]="{ 'is-invalid': submitted && item.iForm.serialNumber.errors }">
                                    </div>
                                    <div class="form-group col-6">
                                        <input type="text" formControlName="year" class="form-control" id="year{{i}}"
                                            placeholder="Year" name="year{{i}}" (keyup)="onMakeOrModelOrYearKeyUp(item)"
                                            [ngClass]="{ 'is-invalid': submitted && item.iForm.year.errors }" mask="0*">
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <input type="text" formControlName="itemDescription" class="form-control"
                                            id="itemDescription{{i}}" placeholder="Item Description"
                                            name="itemDescription{{i}}"
                                            [ngClass]="{ 'is-invalid': submitted && item.iForm.itemDescription.errors }">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 equipment-cost-container">
                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <input type="text" formControlName="equipmentCost" class="form-control"
                                            id="equipmentCost{{i}}" placeholder="Equipment Cost"
                                            name="equipmentCost{{i}}" prefix="$ " mask="separator.2" thousandSeparator=","
                                            [ngClass]="{ 'is-invalid': submitted && item.iForm.equipmentCost.errors }">
                                    </div>
                                </div>
                                Excluding Sales Tax
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-8 invoice-type">
                                <label for="condition">Condition:</label>
                                <input type="radio" formControlName="condition" id="invoice-new{{i}}" value="true"
                                    name="condition">
                                <div>New</div>
                                <input type="radio" formControlName="condition" id="invoice-used{{i}}" value="false"
                                    name="condition">
                                <div>Used</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12 invoice-type">
                                <label for="sameAddres">Is the equipment to be installed at the address
                                    below?</label>
                                <input type="radio" formControlName="sameAddres" id="invoice-same-address-no{{i}}"
                                    value="false" name="sameAddres">
                                <label for="invoice-same-address-no">No</label>
                                <input type="radio" formControlName="sameAddres" id="invoice-same-address-yes{{i}}"
                                    value="true" name="sameAddres">
                                <label for="invoice-same-address-yes">Yes</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-row">
                                    <div class="form-group col-6">
                                        <input type="text" formControlName="address" class="form-control"
                                            id="address{{i}}" placeholder="Address" name="address{{i}}"
                                            [ngClass]="{ 'is-invalid': submitted && item.iForm.address.errors }">
                                    </div>
                                    <div class="form-group col-6">
                                        <input type="text" formControlName="unit" class="form-control" id="unit{{i}}"
                                            placeholder="Unit" name="unit{{i}}"
                                            [ngClass]="{ 'is-invalid': submitted && item.iForm.unit.errors }">
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-6">
                                        <input type="text" formControlName="zip" class="form-control" id="zip{{i}}"
                                            placeholder="Zip" name="zip{{i}}" (keyup)="onZipCodeKeyUp(item)"
                                            [ngClass]="{ 'is-invalid': submitted && item.iForm.zip.errors }">
                                    </div>
                                    <div class="form-group col-6">
                                        <select formControlName="city" id="city{{i}}" class="form-control"
                                            [ngClass]="{ 'is-invalid': submitted && item.iForm.city.errors }">
                                            <option *ngFor="let city of item.cities" [ngValue]="city">{{city}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-6">
                                        <select formControlName="state" id="state{{i}}" class="form-control"
                                            [ngClass]="{ 'is-invalid': submitted && item.iForm.state.errors }">
                                            <option *ngFor="let state of item.states" [ngValue]="state.code">
                                                {{state.name}}</option>
                                        </select>
                                    </div>
                                    <div class="form-group col-6">
                                        <select formControlName="county" id="county{{i}}" class="form-control"
                                            [ngClass]="{ 'is-invalid': submitted && item.iForm.county.errors }">
                                            <option *ngFor="let county of item.counties" [ngValue]="county">{{county}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="add-equipment clearfix col-12" *ngIf="items.length > 1">
                                <button type="submit"
                                    class="btn btn-primary btn-lg col-xl-2 col-lg-4 col-md-6 col-12 float-right"
                                    (click)="removeItemClick(item);">Remove</button>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="add-equipment clearfix" *ngIf="useNumber.value == 'false'">
                    <button type="submit" class="btn btn-primary btn-lg col-xl-5 col-lg-6 col-md-6 col-12 float-right"
                        (click)="addItemClick();">Add additional equipment</button>
                </div>
            </div>
        </div>
        <div class="col-lg-4 invoice-container-parent">
            <div class="invoice-container">
                <div class="invoice-title clearfix">
                    <div>Approved Amount</div>
                    <div>{{offers.maxApproved | currency:'$ ':'code':'.0-0'}}</div>
                </div>
                <form [formGroup]="invoiceForm">
                    <div class="invoice-data">
                        <div>
                            <div>Invoice total:</div>
                            <div>{{getInvoiceTotal() | currency:'$ ':'code':'.0-0'}}</div>
                        </div>
                        <div>
                            <div>Financed Amount:</div>
                            <div class="financed-amount-label" *ngIf="!openEditFinancedAmountPopover">
                                {{offers.requestAmount | currency:'$ ':'code':'.0-0'}}</div>
                            <input *ngIf="openEditFinancedAmountPopover" id="financedAmountInput" #financedAmountInput
                                type="text" formControlName="financedAmountInput"
                                class="form-control financed-amount-input" name="financedAmountInput" prefix="$ "
                                mask="separator.2" thousandSeparator=","
                                [ngClass]="{ 'is-invalid': submitted && invoiceForm.financedAmountInput.errors }">
                        </div>
                        <div class="line"></div>
                        <p class="financed-amount-buttons-container">
                            <span *ngIf="openEditFinancedAmountPopover" (click)="closeEditFinancedAmount()"
                                class="financed-amount-cancel-button">Cancel</span>
                            <fa-icon class="financed-amount-button cancel" *ngIf="openEditFinancedAmountPopover"
                                [icon]="faTimes" (click)="closeEditFinancedAmount()"></fa-icon>
                            <span *ngIf="openEditFinancedAmountPopover" (click)="saveEditFinancedAmount()"
                                class="financed-amount-save-button">Save</span>
                            <fa-icon class="financed-amount-button save" *ngIf="openEditFinancedAmountPopover"
                                [icon]="faCheck" (click)="saveEditFinancedAmount()"></fa-icon>
                            <span *ngIf="!openEditFinancedAmountPopover" (click)="openEditFinancedAmount()"
                                class="financed-amount-edit-button">Edit Financed Amount</span>
                            <fa-icon class="financed-amount-button edit" *ngIf="!openEditFinancedAmountPopover"
                                [icon]="faPen" (click)="openEditFinancedAmount()"></fa-icon>
                        </p>
                        <div>
                            <div>Balance Due:</div>
                            <div>{{getBalanceDue() | currency:'$ ':'code':'.0-0'}}</div>
                        </div>
                        <div>
                            <div>Doc Fees:</div>
                            <div>{{offers.amountDueToday | currency:'$ ':'code':'.0-0'}}</div>
                        </div>
                        <div class="line"></div>
                        <div class="line"></div>
                        <div>
                            <div>Due Today:</div>
                            <div>{{getBalanceDue() + offers.amountDueToday | currency:'$ ':'code':'.0-0'}}</div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="row">
                <div class="col-12">
                    <button type="submit" class="btn btn-primary btn-lg col-12"
                        (click)="openSelectOffersDialog(false); $event.preventDefault();">
                        Continue to Docs
                    </button>
                </div>
                <div class="col-12">
                    <button type="submit" class="btn btn-primary btn-lg col-12"
                        (click)="openSelectOffersDialog(true); $event.preventDefault();">
                        Send Docs to Customer
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<app-select-offer-dialog [offers]="offers" [selectedOfferRadio]="selectedOfferRadio" [invoiceItems]="items"
    (onContinueFromOffers)="continueFromOffers($event);" (onBackFromOffers)="backFromOffers($event);"
    (onContinueFromSummary)="continueFromSummary($event);" (onBackFromSummary)="backFromSummary($event);"
    (onContinueFromAmendment)="continueFromAmendment($event);" (onBackFromAmendment)="backFromAmendment($event);">
</app-select-offer-dialog>
<div class="modal fade" id="attempModal" tabindex="-1" role="dialog" aria-labelledby="attempModal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg w600" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title w-100 text-center position-absolute" id="exampleModalLongTitle">Having problems?
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div>It seems you are having issues sending documents to your customer.</div>
                <div>Please speak with a member of our Customer Care team to get this resolved.</div>
                <div>You can reach them at (888) 509-5592.</div>
            </div>
            <div class="modal-footer">
                <div class="attemps-number mr-auto">(Resend Docs attempt {{numberOfAttempts}} of 3)</div>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" (click)="openSelectOffersDialogAfterQuantityValidation();"
                    data-dismiss="modal" *ngIf="!numberOfDocsExceeded">Continue</button>
            </div>
        </div>
    </div>
</div>
<app-error-dialog [modalId]="'InvoiveError'" [title]="errorTitle" [messageA]="errorMessageA" [messageB]="errorMessageB"
    [messageC]="errorMessageC" [messageBClass]="errorMessageBClass" [dialogClass]="dialogClass">
    <app-footer></app-footer>